export const ROLE_STATUS = {
  ACTIVE: 'active'
};
